import { memo } from 'react'
import Form from 'react-bootstrap/Form';

const { Select } = Form

const BzSelectDropDown = ({ className, dropDownRef, ...props }) => {
    return (
        <Select className={className} ref={dropDownRef} {...props}>
            {props.children}
        </Select>
    )
}

export default memo(BzSelectDropDown);